import { clientContext } from './clientContext';

const ClientContextProvider = clientContext.Provider;

export { ClientContextProvider };
